import { Box, Text, Heading, Flex, Button, SimpleGrid, Icon } from "@chakra-ui/react";
import { FaSearch, FaLayerGroup, FaChartLine } from "react-icons/fa";
import Reveal from "./motion";
import { HomeContent } from "../data/homeContent";

const icons = [FaSearch, FaLayerGroup, FaChartLine];

const scrollTo = (id: string) => {
  const section = document.getElementById(id);
  section?.scrollIntoView({ behavior: "smooth" });
};

type CustomDevProps = { customDev: HomeContent["customDev"] };

const CustomDev = ({ customDev }: CustomDevProps) => (
  <Box as="section" id="custom-dev" py={{ base: 20, md: 28 }} maxW="1400px" mx="auto" px={{ base: 5, md: 8 }}>
    <Reveal textAlign="center" maxW="700px" mx="auto" mb={16}>
      <Text color="lime.700" fontWeight="bold" fontSize="sm" letterSpacing="wide" mb={3}>
        {customDev.eyebrow}
      </Text>
      <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }} mb={5}>
        {customDev.heading}
      </Heading>
      <Text color="slate.700" fontSize={{ base: "sm", md: "md" }}>
        {customDev.body}
      </Text>
    </Reveal>

    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mb={12}>
      {customDev.points.map((p, i) => (
        <Reveal key={p.title} delay={i * 0.12}>
          <Box
            p={7}
            h="100%"
            borderRadius="xl"
            border="1px solid"
            borderColor="chalk.400"
            bg="chalk.50"
          >
            <Icon as={icons[i]} w={5} h={5} color="lime.700" mb={4} />
            <Text fontSize="lg" fontWeight="bold" fontFamily="heading" mb={2}>
              {p.title}
            </Text>
            <Text color="slate.700" fontSize="sm" lineHeight="1.7">
              {p.description}
            </Text>
          </Box>
        </Reveal>
      ))}
    </SimpleGrid>

    <Flex justify="center">
      <Button
        size="lg"
        bg="lime.500"
        color="ink.900"
        fontWeight="bold"
        px={8}
        _hover={{ bg: "lime.400", transform: "translateY(-2px)" }}
        transition="all 0.2s ease"
        onClick={() => scrollTo("contacts")}
      >
        {customDev.cta}
      </Button>
    </Flex>
  </Box>
);

export default CustomDev;
